export default "__VITE_ASSET__DnP5lTlI__"